import { apiGet, apiPost, apiPut, apiDelete } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showFailure } from './notificationActions';

export function getAllPurchaseOrders(subset = 'needs_review', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::FETCH_PURCHASE_ORDERS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/purchase_orders?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          dispatch(displayPurchaseOrders(response, offset || 0));
        })
        .catch((error, textStatus) => {
          dispatch(showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

function displayPurchaseOrders(response, offset) {
  return {
    type: 'LANDLORD_PURCHASE_ORDERS::SHOW_PURCHASE_ORDERS',
    purchaseOrdersResponse: response,
    offset,
  };
}

export function getPurchaseOrderStats() {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::FETCH_PURCHASE_ORDER_STATS',
      payload: apiGet(
        `${Auth.getApiUrl()}/landlords/purchase_order_stats`
      ).catch((error, textStatus) => {
        dispatch(showFailure(error));
        console.error(textStatus);
      }),
    });
  };
}

export function getPurchaseOrder(purchaseOrderId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::FETCH_PURCHASE_ORDER',
      payload: apiGet(
        `${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}`
      ).catch((error, textStatus) => {
        dispatch(showFailure(error));
        console.error(textStatus);
      }),
    });
  };
}

export function getVendors() {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::FETCH_PURCHASE_ORDER_VENDORS',
      payload: apiGet(
        `${Auth.getApiUrl()}/landlords/purchase_orders/vendors`
      ).catch((error, textStatus) => {
        dispatch(showFailure(error));
        console.error(textStatus);
      }),
    });
  };
}

export function createPurchaseOrder(data) {
  let totalCost = data.purchase_order_items
    .map(item => item.total_cost)
    .reduce((acc, curr) => acc + curr);

  let formData = {
    vendor_id: data.vendor_id,
    vendor_name: data.vendor_name,
    property_id: data.property_id,
    project_id: data.project_id || null,
    required_date: data.required_date,
    purchase_order_items: data.purchase_order_items,
    service_requests: data.service_requests,
    total_cost: totalCost,
    internal_comments: data.internal_comments,
    description: data.description,
    title: data.title,
  };

  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::CREATE_PURCHASE_ORDER',
      payload: apiPost(`${Auth.getApiUrl()}/landlords/purchase_order`, formData).catch(error => {
        throw new Error();
      }),
    });
  };
}

export function updatePurchaseOrder(data, purchaseOrderId) {
  let totalCost = data.purchase_order_items
    .map(item => item.total_cost)
    .reduce((acc, curr) => acc + curr);

  let formData = {
    vendor_id: data.vendor_id,
    vendor_name: data.vendor_name,
    property_id: data.property_id,
    project_id: data.project_id || null,
    required_date: data.required_date,
    purchase_order_items: data.purchase_order_items,
    service_requests: data.service_requests,
    total_cost: totalCost,
    internal_comments: data.internal_comments,
    description: data.description,
    title: data.title,
  };

  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::UPDATE_PURCHASE_ORDER',
      payload: apiPut(`${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}`, formData)
        .done(() => {
          return;
        })
        .catch(error => {
          throw new Error();
        }),
    });
  };
}

export function createPurchaseOrderComment(data, purchaseOrderId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::CREATE_PURCHASE_ORDER_COMMENT',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}/comment`,
        data
      ).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}

export function attachPurchaseOrderServiceRequest(data, purchaseOrderId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::ATTACH_PURCHASE_ORDER_SERVICE_REQUEST',
      payload: apiPut(
        `${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}/service_requests`,
        data
      ).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}

export function removePurchaseOrderServiceRequest(purchaseOrderId, serviceRequestId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::REMOVE_PURCHASE_ORDER_SERVICE_REQUEST',
      payload: apiDelete(
        `${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}/service_requests/${serviceRequestId}`
      ).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}

export function attachPurchaseOrderProject(purchaseOrderId, projectId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::ATTACH_PURCHASE_ORDER_PROJECT',
      payload: apiPut(
        `${Auth.getApiUrl()}/landlords/ticketing/projects/${projectId}/purchase_orders/${purchaseOrderId}`
      ).catch(error => {
        dispatch(showFailure(error));
        throw error;
      }),
    });
  };
}

export function removePurchaseOrderProject(purchaseOrderId, projectId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::REMOVE_PURCHASE_ORDER_PROJECT',
      payload: apiDelete(
        `${Auth.getApiUrl()}/landlords/ticketing/projects/${projectId}/purchase_orders/${purchaseOrderId}`
      ).catch(error => {
        dispatch(showFailure(error));
        throw error;
      }),
    });
  };
}

export function getGlAccounts() {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::FETCH_PURCHASE_ORDER_GL_ACCOUNTS',
      payload: apiGet(`${Auth.getApiUrl()}/landlords/purchase_orders/gl_accounts`).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}

export function getExpenseTypes() {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::FETCH_PURCHASE_ORDER_EXPENSE_TYPES',
      payload: apiGet(
        `${Auth.getApiUrl()}/landlords/purchase_orders/expense_types`
      ).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}

export function approvePurchaseOrder(data, purchaseOrderId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::APPROVE_PURCHASE_ORDER',
      payload: apiPut(
        `${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}/approve`,
        data
      ).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}

export function downloadPdf(purchaseOderId) {
  // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
  let windowReference = window.open();

  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/landlords/purchase_orders/${purchaseOderId}/pdf`)
        .done(response => {
          windowReference.location.assign(response.pdf_url);
        })
        .catch(error => {
          dispatch(showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function denyPurchaseOrder(data, purchaseOrderId) {
  return dispatch => {
    return dispatch({
      type: 'LANDLORD_PURCHASE_ORDERS::DENY_PURCHASE_ORDER',
      payload: apiPut(
        `${Auth.getApiUrl()}/landlords/purchase_orders/${purchaseOrderId}/deny`,
        data
      ).catch(error => {
        dispatch(showFailure(error));
        throw new Error();
      }),
    });
  };
}
